import { Link } from 'react-router-dom'
import { SiteContentLayout } from '../components/SiteContentLayout'
import { COMPANY } from '../constants/company'
import { FAQ_PAGE } from '../constants/faq-page'

export function FaqPage() {
  return (
    <SiteContentLayout
      eyebrow={FAQ_PAGE.eyebrow}
      title={FAQ_PAGE.title}
      lead={FAQ_PAGE.lead}
    >
      <div className="content-page__faq">
        {FAQ_PAGE.groups.map((group) => (
          <section key={group.title} className="content-page__section">
            <h2>{group.title}</h2>
            <div className="content-page__accordion">
              {group.items.map((item) => (
                <details key={item.question} className="content-page__details">
                  <summary>{item.question}</summary>
                  <div className="content-page__details-body">
                    {item.answer ? <p>{item.answer}</p> : null}
                    {item.bullets ? (
                      <ul className="content-page__list">
                        {item.bullets.map((bullet) => (
                          <li key={bullet}>{bullet}</li>
                        ))}
                      </ul>
                    ) : null}
                  </div>
                </details>
              ))}
            </div>
          </section>
        ))}
      </div>

      <section className="content-page__card content-page__card--cta">
        <h2>{FAQ_PAGE.stillTitle}</h2>
        <p>{FAQ_PAGE.stillLead}</p>
        <p>
          {COMPANY.legalName}
          <br />
          {COMPANY.address}
        </p>
        <p>
          <a href={COMPANY.phoneHref}>{COMPANY.phoneDisplay}</a>
          <br />
          <a href={COMPANY.emailHref}>{COMPANY.email}</a>
        </p>
        <div className="content-page__cta-row">
          <Link className="content-page__cta" to={FAQ_PAGE.returnsTo}>
            {FAQ_PAGE.returnsLinkLabel}
          </Link>
          <Link className="content-page__cta content-page__cta--ghost" to={FAQ_PAGE.vendorTo}>
            {FAQ_PAGE.vendorLinkLabel}
          </Link>
        </div>
      </section>
    </SiteContentLayout>
  )
}
